<template>
    <div>
        <base-header type="gradient-default" class="pb-7 pt-5 pt-md-8">
            <div class="row">
                <div class="col-xl-5 col-md-12 col-lg-5">
                    <stats-card title="Edição"
                                type="gradient-red"
                                :sub-title="diario.dia_numero | padDigits"
                                class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span class="text-nowrap font-weight-500">{{diario.dia_data_publicacao | dateExtensao}}</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-7 col-md-12 col-lg-7">
                    <stats-card title="Baixar"
                                type="gradient-orange"
                                :sub-title="diario.dia_downloads+' downloads'"
                                class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <base-button outline type="secondary" @click="dowload(diario, 'ONLINE')" size="sm">Visualizar PDF</base-button>
                            <base-button outline type="secondary" @click="dowload(diario)" size="sm">Baixar PDF</base-button>
                            <base-button v-show="!versaoAnterior" outline type="secondary" @click="dowload(diario, 'HTML')" size="sm">Baixar HTML</base-button>
                            <base-button v-if="!entidade.ent_diario_html" v-show="!versaoAnterior" outline type="secondary" @click="dowload(diario, 'ZIP')" size="sm">Baixar todas as publicações</base-button>
                          <div v-if="suplemento">
                            <div class="col text-left mt-3">
                              <h4 class="mb-0 text-uppercase">Suplemento</h4>
                              <base-button outline type="secondary" @click="dowload(suplemento)" size="sm">Baixar Suplemento PDF</base-button>
                              <base-button v-show="!versaoAnterior" outline type="secondary" @click="dowload(suplemento, 'HTML')" size="sm">Baixar Suplemento HTML</base-button>
                              <base-button v-if="!entidade.ent_diario_html" v-show="!versaoAnterior" outline type="secondary" @click="dowload(suplemento, 'ZIP')" size="sm">Baixar todas as publicações</base-button>
                            </div>
                          </div>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div v-if="!entidade.ent_diario_html" class="container-fluid mt--8">
            <div class="row">
                <div class="col-12">
                    <table-diario-detalhe :versaoanterior="versaoAnterior" :titulos="titulos"></table-diario-detalhe>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import {dowloadDiario} from "@/plugins/webdom";
  import {getBaseURL} from "../config"
  import TableDiarioDetalhe from './Diario/TableDiarioDetalhe';
  import {getDiario} from '@/api/diario';

  export default {
    components: {
      TableDiarioDetalhe
    },
    data() {
      return {
        baseUrl: getBaseURL(),
        diario: {},
        diarios: [],
        titulos: [],
        suplemento:null,
      };
    },
    methods: {
      listDiarios() {
        getDiario(this.$route.params.dia_numero).then(response => {
          if (response.status) {
            this.diario = response.data.diario;
            this.titulos = response.data.titulos;
            this.suplemento = response.data.suplemento;
          }
        }).catch(error => {
          //console.log(error);
        }).finally(finalit => {

        })
      },
      dowload(diario, tipo = 'PDF') {
        dowloadDiario(diario, tipo)
      }
    },
    computed: {
      entidade() {
        return this.$store.getters.entidade;
      },
      versaoAnterior() {
        return (this.diario.dia_numero < this.$store.getters.entidade.ent_diario_inicial)
      }
    },
    mounted() {

    },
    created() {
      this.listDiarios();
    }
  };
</script>
<style>
</style>
